import { UrlSearchParam } from 'consts/url'
import { RegionStore } from 'modules/region/region'
import { Channel } from 'types'

import { useUrlSearchParams } from './useUrlSearchParams'

export const useChannel = () => {
  const { urlSearchParams } = useUrlSearchParams()
  const channel = (urlSearchParams[UrlSearchParam.Channel]?.[0] ??
    Channel.Chat) as Channel
  const currentRegion = RegionStore.region

  return {
    channel,
    regionedChannel: `${channel}:${currentRegion}`,
    entityName: channel === Channel.Dante ? 'task' : 'ticket',
    specialisationLabel: channel === Channel.Dante ? 'topic' : 'specialisation',
    isDante: channel === Channel.Dante,
    isChat: channel === Channel.Chat,
  }
}
